import { v4 as uuidv4 } from 'uuid'

export const generateUniqueKey = (pre: string): string => {
  return `${pre}_${uuidv4()}`
}

export const generateUniqueKeyWithNoPrefix = (): string => {
  return `${uuidv4()}`
}

export const generateUniqueKeyWithTimestamp = (): { tempId: string; timestamp: number } => {
  return {
    tempId: `${uuidv4()}`,
    timestamp: Date.now()
  }
}
